export class Drawer extends HTMLElement {
  private openButtons: NodeListOf<HTMLElement> | null = null;
  private closeButton: HTMLButtonElement | null = null;
  private overlay: HTMLElement | null = null;
  private isOpen: boolean = false;
  private drawerId: string = "";

  constructor() {
    super();
    this.drawerId = this.dataset.drawerId || "";
    this.closeButton = this.querySelector(".drawer__close-button");
    this.overlay = this.querySelector(".drawer__overlay");

    this.bindEvents();
  }

  bindEvents() {
    // Find all opener buttons for this drawer
    this.openButtons = document.querySelectorAll(`[data-drawer-opener="${this.drawerId}"]`);

    // Bind open events
    this.openButtons?.forEach((button) => {
      button.addEventListener("click", this.open.bind(this));
    });

    // Bind close events
    this.closeButton?.addEventListener("click", this.close.bind(this));
    this.overlay?.addEventListener("click", this.close.bind(this));

    // Close on ESC key
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.isOpen) {
        this.close();
      }
    });

    // Handle URL fragment for deep linking
    window.addEventListener("load", this.checkUrlHash.bind(this));
    window.addEventListener("hashchange", this.checkUrlHash.bind(this));
  }

  /**
   * Check if URL hash matches this drawer's ID for deep linking
   */
  checkUrlHash() {
    const hash = window.location.hash.substring(1);
    if (hash === this.drawerId) {
      this.open();
    }
  }

  /**
   * Open the drawer
   */
  open() {
    this.setAttribute("open", "");
    this.isOpen = true;
    document.body.style.overflow = "hidden"; // Prevent background scrolling

    // Dispatch custom event
    this.dispatchEvent(
      new CustomEvent("drawer:opened", {
        bubbles: true,
        detail: { drawerId: this.drawerId },
      })
    );
  }

  /**
   * Close the drawer
   */
  close() {
    this.removeAttribute("open");
    this.isOpen = false;
    document.body.style.overflow = "";

    // Remove the hash from URL if it corresponds to this drawer
    if (window.location.hash.substring(1) === this.drawerId) {
      history.pushState("", document.title, window.location.pathname + window.location.search);
    }

    // Dispatch custom event
    this.dispatchEvent(
      new CustomEvent("drawer:closed", {
        bubbles: true,
        detail: { drawerId: this.drawerId },
      })
    );
  }
}

customElements.define("drawer-component", Drawer);
